import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  checkAuthToken,
  getaccessToken,
} from "../infrastructure/backendService";
import Layout from "../components/layout/layout";
import PrivateRoute from "./privateRoutes";
import Home from "../components/home/home";
import Dashboard from "../components/devotee/dashboard/dashboard";
import Donation from "../components/devotee/donation/Donation";
import UserDetails from "../components/common/user/userDetails";
import Register from "../components/common/user/register";
import DonationReport from "../components/devotee/donationReport/DonationReport";
import ChangePassword from "../components/login/changePassword";
import MeetingMinutes from "../components/meetingMinutes/meetingMinutes";
import RegisterDevotee from "../components/devoteeManagement/RegisterDevotee";
import ManagerDashboard from "../components/managerDashboard/managerDashboard";
import DevoteeService from "../components/devoteeService";
import DevoteeServiceRoutes from "../components/devoteeService/devoteeServiceRoutes";
import DevoteeManagement from "../components/devoteeManagement";
import DevoteeManagementRoute from "../components/devoteeManagement/devoteeMangementRoutes";
import DataEntry from "../components/dataEntry";
import DataEntryType from "../components/dataEntry/dataEntryRoutes";
import SystemSettings from "../components/systemSettings";
import SystemSettingsRoute from "../components/systemSettings/SystemSettingRoutes";
import ExpenseVoucher from "../components/expenseVoucher";
import ExpenseVoucherType from "../components/expenseVoucher/expenseVoucherRoutes";
import DevoteeAppointments from "../components/devoteeAppointments/DevoteeAppointments";
import DevoteeTangibles from "../components/devoteeAppointments/DevoteeAppointments";
import Login from "../components/login/login";
import MangementTeam from "../components/Information/managementTeam";
import PoojaItems from "../components/Information/PoojaItems/PoojaItems";
import Awards from "../components/Information/awards";
import ContactInfoTabComponent from "../components/contactUs/ContactInfo/contactinfoTabComponent";
import PoojaItemsTabComponent from "../components/Information/PoojaItems/poojaItemsTabComponent";

import Religious from "../components/Information/ServiceInformation/religious";
import Human from "../components/Information/ServiceInformation/human";
import YouthandEducation from "../components/Information/ServiceInformation/youthandEducation";
import Feedback from "../components/contactUs/feedback";
import RefundPolicy from "../components/Information/refundPolicy";
import EventFacilities from "../components/Information/eventFacilities";
import Overview from "../components/Information/overview";
import Newsletter from "../components/Information/newsletter";
import CalenderHome from "../components/common/Calender/CalenderHome";
import PrayerBhajana from "../components/Information/PrayerBhajana";
import AccordionComponent from "../components/contactUs/ContactInfo/faqs";
import CreditCardPayment from "../components/devotee/donation/creditCardPayment";
import Check from "../components/devotee/donation/check";
import DevoteeBooking from "../components/devotee/devoteeBooking/devoteeBooking";
import DevoteeBookingRoutes from "../components/devotee/devoteeBooking";
import AboutTemple from "../components/others/aboutTemple";
import Volunteer from "../components/volunteerRegistration/volunteer";
import ReportSection from "../components/reportSection";
import ReportSectionRouters from "../components/reportSection/reportSectionRouters";
import Priests from "../components/Information/priests";

import ServicesMenuTabComponent from "../components/ServicesMenu/servicesMenuTabComponent";
import ServiceinformationTabComponent from "../components/Information/ServiceInformation/serviceinformationTabComponent";
import OverviewCms from "../components/Information/overviewCms";
import Cultural from "../components/ServicesMenu/cultural";
import YouthAndEducationTabComponent from "../components/ServicesMenu/youthAndEducationTabComponent";
import GoldenAgersTabComponent from "../components/ServicesMenu/goldenAgersTabComponent";
import GoldenAgersActivity from "../components/ServicesMenu/goldenAgersActivity";
import EducationalActivities from "../components/ServicesMenu/educationalActivities";
import SpritualActivities from "../components/ServicesMenu/spritualActivities";
import HealthAndWellness from "../components/ServicesMenu/healthAndWealth";
import FuneralServices from "../components/ServicesMenu/funeralServices";
import InHouseSupport from "../components/ServicesMenu/inHouseSupport";
import RetirementPlanning from "../components/ServicesMenu/retirementPlanning";
import YoungadultsTabComponent from "../components/ServicesMenu/youngadultsTabComponent";
import HumanservicesFaqs from "../components/ServicesMenu/humanservicesFaqs";
import Receipt from "../components/common/Receipt";
import TimeSlots from "../components/volunteerRegistration/timeSlots/timeSlots";
import SuccessComponent from "../components/volunteerRegistration/successComponent/successComponent";
import PaymentSuccessComponent from "../components/managerDashboard/managerCartItems/paymentSucess";
import EventsHtmlContent from "../components/devotee/dashboard/events/eventsHtmlContent";
import PayPalComponent from "../components/common/modeOfPayment/payPal/payPal";
import HallContractFormComponent from "../components/hallContractForm/hallContractForm";
import PriestScheduleReport from "../components/priestSchedule/priestScheduleReport";
import PriestWeeklySchedule from "../components/devoteeService/priestSchedule/priestWeeklySchedule";
import { RoutingURLs } from "../components/common/RoutingURLs";

const Router: React.FunctionComponent = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  const checkUserToken = (): void => {
    if (!checkAuthToken()) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
    }

    console.log("index---", isLoggedIn);
  };
  useEffect(() => {
    checkUserToken();
  }, [getaccessToken()]);

  useEffect(() => {
    window.scroll(0, 200);
  }, []);

  return (
    <>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/priestScheduleReport" element={<PriestScheduleReport/>} /> */}
            <Route
              path={RoutingURLs.dashboard}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutingURLs.donations}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <Donation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${RoutingURLs.user}/:userName`}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <UserDetails />
                </PrivateRoute>
              }
            />
            <Route path={RoutingURLs.register} element={<Register />} />
            {/* <Route
                     path="/donationreport"
                     element={
                        <PrivateRoute roles={['devotee']}>
                           <DonationReport />
                        </PrivateRoute>
                     }
                  /> */}
            <Route
              path={RoutingURLs.changePassword}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <ChangePassword />
                </PrivateRoute>
              }
            />
            <Route
              path={RoutingURLs.meetingMinutes}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <MeetingMinutes />
                </PrivateRoute>
              }
            />
            {/* <Route[]
                     path="/expenseVoucher"
                     element={
                        <PrivateRoute roles={['manager']}>
                           <Route index element={<ExpenseVoucher />} />
                           <Route path=":expenseVoucherType" element={<ExpenseVoucherType />} />
                        </PrivateRoute>
                     }
                  /> */}
            {/* <Route path="expenseVoucher" element={<ExpenseVoucher />}>
                     <Route path=":expenseVoucherType" element={<ExpenseVoucherType />} />
                  </Route> */}
            {/* <Route
                     path="/dataentry"
                     element={
                        <PrivateRoute roles={['manager']}>
                           <Route index element={<DataEntry />} />
                           <Route path=":dataEntryType" element={<DataEntryType />} />
                        </PrivateRoute>
                     }
                  /> */}
            <Route
              path={RoutingURLs.devoteeRegister}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <RegisterDevotee />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute roles={["manager"]}>
                  <ManagerDashboard />
                </PrivateRoute>
              }
            >
              <Route path="managerDashboard">
                <Route path="devoteeService" element={<DevoteeService />}>
                  <Route
                    path=":devoteeServiceType"
                    element={<DevoteeServiceRoutes />}
                  />
                </Route>
                {/* <Route path="devoteeManagement" element={<DevoteeManagement />}>
                  <Route
                    path=":devoteeManagementType"
                    element={<DevoteeManagementRoute />}
                  />
                </Route> */}
                <Route path="ReportsSection" element={<ReportSection />}>
                  <Route
                    path=":reportSectionType"
                    element={<ReportSectionRouters />}
                  />
                </Route>
                <Route path="dataentry" element={<DataEntry />}>
                  <Route path=":dataEntryType" element={<DataEntryType />} />
                </Route>
                <Route path="systemSettings" element={<SystemSettings />}>
                  <Route
                    path=":dataEntryType"
                    element={<SystemSettingsRoute />}
                  />
                </Route>
                <Route path="expenseVoucher" element={<ExpenseVoucher />}>
                  <Route
                    path=":expenseVoucherType"
                    element={<ExpenseVoucherType />}
                  />
                </Route>
                <Route
                  path="Devotee Appointments (COVID)"
                  element={
                    <PrivateRoute roles={["devotee"]}>
                      <DevoteeAppointments />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="Devotee Tangibles"
                  element={
                    <PrivateRoute roles={["devotee"]}>
                      <DevoteeTangibles />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Route>
            <Route path={RoutingURLs.priestScheduling} element={<PriestWeeklySchedule />} />
            <Route path={RoutingURLs.login} element={<Login />} />
            <Route path={RoutingURLs.managementTeam} element={<MangementTeam />} />
            <Route path={RoutingURLs.infoPoojaItems} element={<PoojaItems />} />
            <Route path={RoutingURLs.awards} element={<Awards />} />
            <Route path={RoutingURLs.contactInfo} element={<ContactInfoTabComponent />} />
            <Route path={RoutingURLs.poojaItems} element={<PoojaItemsTabComponent />} />
            <Route
              path={RoutingURLs.serviceInformation}
              element={<ServiceinformationTabComponent />}
            />
            <Route path={RoutingURLs.religious} element={<Religious />} />
            <Route path={RoutingURLs.human} element={<Human />} />
            <Route path={RoutingURLs.youthAndEducation} element={<YouthandEducation />} />
            <Route path={RoutingURLs.feedback} element={<Feedback />} />
            <Route path={RoutingURLs.refundPolicy} element={<RefundPolicy />} />
            <Route path={RoutingURLs.eventFacilities} element={<EventFacilities />} />
            <Route path={RoutingURLs.overview} element={<Overview />} />
            <Route path={RoutingURLs.newsletter} element={<Newsletter />} />
            <Route path={RoutingURLs.cultural} element={<Cultural />} />
            <Route path={RoutingURLs.calendar} element={<CalenderHome />} />
            <Route path={RoutingURLs.bhajana} element={<PrayerBhajana />} />
            <Route path={RoutingURLs.faqs} element={<AccordionComponent />} />
            <Route path={RoutingURLs.creditPayment} element={<CreditCardPayment />} />
            <Route path={RoutingURLs.check} element={<Check />} />
            <Route
              path="devoteebooking"
              element={
                <PrivateRoute roles={["devotee"]}>
                  <DevoteeBooking />
                </PrivateRoute>
              }
            >
              <Route
                path=":devoteeBookingType"
                element={
                  <PrivateRoute roles={["devotee"]}>
                    <DevoteeBookingRoutes />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path={RoutingURLs.aboutTemple} element={<AboutTemple />} />
            <Route path={RoutingURLs.volunteer} element={<Volunteer />} />
            <Route path={RoutingURLs.priests} element={<Priests />} />
            <Route
              path={RoutingURLs.humanServices}
              element={<ServicesMenuTabComponent />}
            />
            <Route path="/cmmcontenttest" element={<OverviewCms />} />
            <Route
              path={RoutingURLs.servicesYouthAndEducation}
              element={<YouthAndEducationTabComponent />}
            />
            <Route path={RoutingURLs.goldenAgers} element={<GoldenAgersTabComponent />} />
            <Route path={RoutingURLs.educational} element={<EducationalActivities />} />
            <Route path={RoutingURLs.spirtual} element={<SpritualActivities />} />
            <Route path={RoutingURLs.health} element={<HealthAndWellness />} />
            <Route path={RoutingURLs.funeral} element={<FuneralServices />} />
            <Route path={RoutingURLs.retirement} element={<RetirementPlanning />} />
            <Route path={RoutingURLs.inHouse} element={<InHouseSupport />} />
            <Route path={RoutingURLs.educational} element={<GoldenAgersActivity />} />
            <Route path={RoutingURLs.spirtual} element={<GoldenAgersActivity />} />
            <Route path={RoutingURLs.youngAdults} element={<YoungadultsTabComponent />} />
            <Route path={RoutingURLs.humanServicesFaqs} element={<HumanservicesFaqs />} />
            <Route path={RoutingURLs.receipt} element={<Receipt />} />
            <Route path={`${RoutingURLs.timeslots}/:age`} element={<TimeSlots />} />
            <Route path="/success/:success" element={<SuccessComponent />} />
            <Route
              path="/paymentsuccess"
              element={<PaymentSuccessComponent />}
            />
            <Route path="/htmltEventscontent" element={<EventsHtmlContent />} />
            <Route
              path={RoutingURLs.hallForm}
              element={
                <PrivateRoute roles={["devotee"]}>
                  <HallContractFormComponent />
                </PrivateRoute>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </>
  );
};

export default Router;
